import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { IvrAssignedTenantDto } from './ivr-assigned-tenant.dto';

@Api('api/agentic-cx/ivr-instance')
export class IvrInstanceDto extends DtoHasApi {
  id: string;
  name: string;
  ipAddress: string;
  port: number;
  isActive: boolean;
  isDefault: boolean;
  assignedTenants?: IvrAssignedTenantDto[];
}
